<template>
  <div>
    <Header title="已处理" type="0" route="/pass/index"></Header>
    <div class="unDeal">
      <van-search
        v-model="value"
        placeholder="请输入关键词"
      />
<!-- 筛选框放在搜索框下方 -->
      <div class="filter-wrapper"  v-if="schoolCode === '13383'">
        <!-- 添加文字标签 -->
        <span class="filter-label">流程类型：</span>
        <van-dropdown-menu>
          <van-dropdown-item v-model="filterValue" :options="filterOptions" placeholder="流程类型" />
        </van-dropdown-menu>
      </div>

      <NOdata
        v-if="this.dealList.length == 0"
        title="未查询到处理信息"
      ></NOdata>
      <div v-else class="content">
        <div v-for="(item, index) of dealList" :key="index" @click="goRecord(item)">
          <p>{{ item.lcmc }}</p>
          <ul>
            <li>申请人：{{ item.shmc }}</li>
            <li>创建时间：{{ item.shsj }}</li>
          </ul>
          <!-- <span class="iconfont icon iconicon-test"></span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      schoolCode: sessionStorage.getItem("schoolCode"),
      value: "",
      list: [],
      filterValue: '', // 下拉框选中的值
      // 下拉框选项数据
      filterOptions: [
        { text: '全部', value: '' }
      ]
    };
  },
  methods: {
    // 获取待处理list
    async getDeal() {
      const res = await Api.historyTask({
        lcmc:'',
        shmc:''
      });
      this.list = res.data;
      if (this.schoolCode==="13383" && this.list && this.list.length > 0) {
        const uniqueLcmc = new Set();
        this.list.forEach(item => {
          if (item.lcmc) {
            uniqueLcmc.add(item.lcmc);
          }
        });
        this.filterOptions = [{ text: '全部', value: '' }];
        uniqueLcmc.forEach(lcmc => {
          this.filterOptions.push({ text: lcmc, value: lcmc });
        });
      }
    },
    goRecord(item) {
      if(this.schoolCode==="13383"){
        if(item.ywcode==="009"){
          this.$router.push({
            path: "/noStop",
            query: {
              changeId: item.ywinstanceid
            }
          });
        }
        else if(item.ywcode==="007"||item.ywcode==="074"){
          this.$router.push({
            path: "/recordDetail",
            query: {
              ywinstanceid: item.ywinstanceid
            }
          });
        }
      }



    },
  },
  created() {
    // 获取待处理list
    this.getDeal();
  },
  computed: {
    dealList: function() {
      var value = this.value;
      var filterKey = this.filterValue;

      // 首先处理搜索关键词筛选
      let filteredList = this.list;
      if (value) {
        filteredList = filteredList.filter(function(product) {
          return Object.keys(product).some(function(key) {
            return (
              String(product[key])
                .toLowerCase()
                .indexOf(value) > -1
            );
          });
        });
      }

      // 然后处理流程类型筛选（当选择了特定流程类型时）
      if (this.schoolCode === '13383' && filterKey) {
        filteredList = filteredList.filter(function(product) {
          return String(product.lcmc).toLowerCase() === filterKey.toLowerCase();
        });
      }
      return filteredList;
    }
  }
};
</script>
<style lang="less" scoped>
.unDeal {
  padding: 5% 5% 0;

  /* 搜索框样式 */
  .van-search {
    padding: 0;
    height: 44px;
    background: #f4f5ff;
    border-radius: 3px;
    margin-bottom: 5%;
  }

  /* 筛选器包装器 - 放在搜索框下方 */
  .filter-wrapper {
    display: flex;
    align-items: center;
    justify-content: center; /* 改为flex-start使内容左对齐 */
    gap: 0; /* 移除间距，让筛选框紧贴标签 */
    margin-top: -5%;
  }

  /* 筛选标签样式 */
  .filter-label {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #212f6e;
    white-space: nowrap;
    /*margin-right: 5px; !* 只保留少量右边距，确保紧贴但不重叠 *!*/
  }

  /* 调整下拉框样式 */
  .filter-wrapper .van-dropdown-menu {
    min-width: 120px;
    text-align: left;
    background: #f4f5ff;
    overflow: hidden;
  }

  .filter-wrapper .van-dropdown-menu__bar {
    background: #f4f5ff;
    justify-content: flex-start; /* 确保下拉框内部元素也左对齐 */
  }
  .filter-wrapper .van-dropdown-item {
    text-align: left; /* 确保下拉项文本左对齐 */
  }
  .van-search .van-cell,
  .van-search__content,
  .van-field__control {
    background: #f4f5ff;
  }

  .van-field__control::-webkit-input-placeholder {
    font-family: PingFangSC-Light;
    font-size: 16px;
    color: #757da3 !important;
    letter-spacing: 0;
  }
  .van-field__control::-moz-input-placeholder {
    font-family: PingFangSC-Light;
    font-size: 16px;
    color: #757da3 !important;
    letter-spacing: 0;
  }
  .van-field__control::-ms-input-placeholder {
    font-family: PingFangSC-Light;
    font-size: 16px;
    color: #757da3 !important;
    letter-spacing: 0;
  }
  .content {
    div {
      background: #f8f8f8;
      border-radius: 5px;
      padding: 3% 0 3% 6%;
      margin-bottom: 5%;
      position: relative;

      p {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }

      ul li {
        font-family: PingFangSC-Light;
        font-size: 12px;
        color: #757da3;
        letter-spacing: 0;
        margin-bottom: 1%;
      }
      span {
        position: absolute;
        top: calc(50% - 6px);
        right: 5%;
      }
    }
  }
  .icon {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/pass/deal.vue